import { AppEntities } from "../../../../config/entities";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const CashierShiftList = () => {
  const fields = [{ title: "Name", fieldName: "name" }];

  return (
    <>
      <NewCatalogListView fields={fields} entity={AppEntities.CashierShift} />
    </>
  );
};

export default CashierShiftList;
